import _ from 'lodash';

import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';
import { getConditionalObject } from 'utils/data';

export const getConfigFields = ({ customFields }) =>
  (customFields.items || []).reduce((acc, i) => {
    const fieldId = [
      'obCustomFields',
      '.',
      i.columnName,
      i.customFieldInputName,
      i.submissionForm,
    ].join('');

    const getType = () => {
      if (_.size(i.options)) {
        return FieldType.SELECT;
      }

      return FieldType.INPUT;
    };

    acc[fieldId] = {
      fieldId,
      type: getType(),
      nameInModel: fieldId,
      submissionForm: i.submissionForm,
      inputProps: {
        ...getConditionalObject(i.valueType === 'Integer' && !_.size(i.options), {
          type: FieldInputType.INT,
        }),
        ...getConditionalObject(!!_.size(i.options), () => ({
          options: _.map(i.options, i => ({ ...i, value: `${i.value}` })),
          disableClearable: true,
        })),
        placeholder: i.displayName || i.customFieldDescription,
        label: i.displayName || i.customFieldDescription,
        required: i.isRequired,
        disabled: false,
      },
    };

    return acc;
  }, {});
